import RecoverForm from 'modules/Forms/Auth/Recover'
import React from 'react'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'
import { ROUTES } from 'constants/routes'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { Typography } from 'gu-ui-kit'

const Recover = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const pathGen = useGeneratePathI18n()

  return (
    <>
      <Helmet defer={false}>
        <title>{t('auth::recover.title')}</title>
      </Helmet>
      <Typography
        className={'margin-bottom-40'}
        component={'h1'}
        variant={'Body-Accent-40'}
        color={'Label-Fifth'}
      >
        {t('auth::recover.title')}
      </Typography>
      <RecoverForm
        onClose={(email) =>
          history.push(pathGen(ROUTES.AUTH_RECOVER_SENT, { email }))
        }
      />
    </>
  )
}

export default Recover
